import { config } from "@/lib/config";

export default function SelfTrustHeader() {
  return (
    <div className="w-full">
      <img
        className="mx-auto"
        src={`${config.basePath}/images/onbizalom.png`}
        alt=""
        width="100%"
      />
    </div>
  );
}
